<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { api } from 'src/plugins/axios'

export default {
  name: 'Scheduler',
  components: {
  },
  data () {
    return {
      userToken: window.localStorage.getItem('user-token')
    }
  },
  computed: {
    ...mapGetters('classes', [
      'getSelectedInstructors'
    ]),
    ...mapState('classes',{
      'scheduleUploadOpen' : s => s.scheduleUploadOpen
    }),
    ...mapState('auth',{
      'isApproved' : s => s.user.APPROVED
    }),
    // Check to see if the user is JUST a recruiter
    onlyIsRecruiter (){
      let vm = this
      return vm.$p(['RECRUITER']) && !vm.$p(['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR'],'or')
    },
    isApprovedInstructor(){
      let isInstructor = this.$p(['INSTRUCTOR'])
      if(isInstructor) return this.currentUser().APPROVED_INSTRUCTOR
      return true
    }
  },
  methods: {
    ...mapMutations('classes', [
      'updateAddEditClassOpenState',
      'updateModalMode',
      'updateModalLoading',
      'updateSessionInformation',
      'updateSelectedSession',
      'setScheduleUploadOpen'
    ]),
    ...mapActions('classes', [
      'getClassInformation',
      'one'
    ]),
    createClass(){
      this.one({
        mode: "add",
        newClass: true
      })
    },
    scheduleUpload(){
      this.setScheduleUploadOpen(true)
    }
  },
  created: function () {
    let vm = this
    
    // Refresh Tie-In
    vm.$root.$on('schedulerRefresh', () => {
      setTimeout(() => {
        vm.kendoScheduler.data("kendoScheduler").dataSource.read()
      }, 20)
    })
    
  },
  mounted () { 
    let vm = this;

    (function ($, kendo) {
      vm.kendoScheduler = $('#classes-scheduler').kendoScheduler({
        date: new Date(),
        views: [
            "day",
            "week",
            { type: "month", selected: true },
            "agenda",
            "timeline"
        ],
        edit: function (e) {
          // Disable creating if recruiter
          if(vm.$p(['RECRUITER']) && !vm.$p(['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR'],'or') && !id){            
            return prevent(e)
          }

          let id = e.event.CLASS_ID
          let mode = id === "" ? "add" : "edit"
          vm.one({
            id: id,
            mode: id === "" ? "add" : "edit",
            start: (mode === 'edit') ? e.event.start : null,
            end: (mode === 'edit') ? e.event.end : null,
            newClass: (mode === 'add') ? true : false
          })

        },
        cancel: function () {
          vm.updateAddEditClassOpenState(false)   
          vm.updateModalMode(null)
        },
        moveStart: prevent,
        moveEnd: prevent,
        resize: prevent,
        resizeStart: prevent,
        dataSource: {
            batch: true,
            transport: {
                read: {
                    url () {
                      return process.env.API + '/calendar/'
                    },
                    data(){
                      return vm.getSelectedInstructors
                    },
                    beforeSend (xhr) {
                      xhr.setRequestHeader('Authorization',vm.userToken)
                    },
                    type: 'POST',
                    dataType: 'json'
                },
                update: {
                    url: process.env.API + "/calendar/update",
                    dataType: "json",
                    beforeSend (xhr) {
                      xhr.setRequestHeader('Authorization',vm.userToken)
                    }
                },
                create: {
                    url: process.env.API + "/calendar/add",
                    dataType: "json",
                    beforeSend (xhr) {
                      xhr.setRequestHeader('Authorization',vm.userToken)
                    }
                },
                destroy: {
                    url: process.env.API + "/calendar/destroy",
                    dataType: "json"
                }
            },
            schema: {
                model: {
                    id: "taskId",
                    fields: {
                        taskId: { from: 'SESSION_ID' },
                        title: { from: "title", defaultValue: "No title" },
                        start: { type: "date", from: "SESSION_START_DATE" },
                        end: { type: "date", from: "SESSION_END_DATE" },
                        syncAddress: { type: 'boolean' },
                        syncInstructors: { type: 'boolean' },
                        syncStudents: { type: 'boolean' }
                    }
                }
            }
        }
      })

      function prevent(e){
        e.preventDefault()
      }

      let $kendoScheduler = $('#classes-scheduler').data("kendoScheduler")

      $(document).off().on('toggleNavDrawer', function () {
        setTimeout(function () {
          $kendoScheduler.resize()
        }, 150)
      })
    })(window.jQuery, window.kendo)
  }
}
</script>

<template>
  <div id="scheduler-wrapper" class="k-content">
    <div id="classes-scheduler"></div>
    <q-page-sticky 
        position="bottom-right" :offset="[18, 18]" 
        v-if="$p(['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR'],'or') && !onlyIsRecruiter && isApprovedInstructor">
      <q-fab
        color="blue"
        icon="add"
        direction="up"
      >
        <q-fab-action
          color="primary"
          @click="createClass()"
          icon="add"
        >
          <q-tooltip anchor="center left" self="center right" :offset="[20, 0]">Add Class</q-tooltip>
        </q-fab-action>
        <q-fab-action
          color="positive"
          icon="cloud_upload"
          @click="scheduleUpload()"
        >
          <q-tooltip anchor="center left" self="center right" :offset="[20, 0]">Upload Schedule</q-tooltip>
        </q-fab-action>        
      </q-fab>
    </q-page-sticky>
  </div>
</template>

<style lang="stylus">
  #classes-scheduler,
  .k-scheduler,
  #scheduler-wrapper
    height 100%
    .k-event
      cursor pointer
  .k-overlay
    display none !important 
  .k-widget.k-window
    display none !important
  .k-event-actions
    .k-icon.k-i-close
      display none
  .k-event:hover .k-resize-handle, .k-event-active .k-resize-handle, .k-scheduler-mobile .k-event-active:hover .k-resize-handle{
    visibility hidden
  }
</style>
